// extracted by mini-css-extract-plugin
export default {"container":"InputMessage_container__Ht8BX","open":"InputMessage_open__01Xz8","message":"InputMessage_message__ulZj-"};